import React from 'react';
import { Button, DynamicForm } from 'components';
import { Props } from 'types/modals';
import useFormHandler from 'hooks/useFormHandler';
import Base from '../../base';
import schema from './schema';

const CreationAreaModal = ({ closing, onClose }: Props) => {
  const formHandler = useFormHandler(schema);

  return (
    <Base
      header="Add area"
      closing={closing}
      onClose={onClose}
      size="md"
      footer={
        <Button
          text="Create"
          disabled={!formHandler.valid || formHandler.isSubmitting}
          onClick={() => {
            formHandler.setIsSubmitting(true);
            onClose(formHandler.data);
          }}
        />
      }
    >
      <div className="modal-tag">
        <DynamicForm handler={formHandler} />
      </div>
    </Base>
  );
};

export default CreationAreaModal;
